export default {
      id: "generator-off-usage",
      viewBox: "0 0 85 62",
      url: __webpack_public_path__ + "img/icons.svg#generator-off",
      toString: function () {
        return this.url;
      }
    }